import { Component, EventEmitter, Input, Output } from '@angular/core'

import { ScopeComponent } from '@app/features/scoping/models/component.model'
import { UpdateRolePayload, ScopeElementsConfig } from '../models'
import { trackById } from '@app/shared/utils/utils'

@Component({
  selector: 'scope-departments',
  templateUrl: './departments.component.html',
  styleUrls: ['./departments.component.scss'],
})
export class DepartmentsComponent {
  @Input() config: ScopeElementsConfig
  @Input() level: number
  @Input() component: ScopeComponent

  @Output() onOverrideRateCardRoleHours = new EventEmitter<UpdateRolePayload>()
  @Output() onUpdateRole = new EventEmitter<UpdateRolePayload>()

  protected readonly trackById = trackById
}
